export default {
    data() {
        return {
            name: null,
            server: {}
        }
    },

    methods: {
        bootModuleFromState() {
            this.$set(
                this,
                'server',
                _.get(this.$state, `${this.name.split('module.')[1]}`, {})
            )

            delete this.$state[this.name]

            this.bootModuleHandler()
        },

        bootModuleHandler() {
            //
        }
    },

    created() {
        this.bootModuleFromState()
    }
}